import { render } from "./ItBeratungPage.vue?vue&type=template&id=70a1e351"
import script from "./ItBeratungPage.vue?vue&type=script&lang=js"
export * from "./ItBeratungPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__